import {BaseSchema} from "./BaseSchema";
import dayjs from "dayjs";
import {formatSku, getUrlName} from "../utilities/helper";
import {isArray} from "lodash";

export class ProductSchema extends BaseSchema {
    entry = {};
    imagesProduct = [];
    link = "";
    reviewG = [];

    constructor(entry, imagesProduct, breadCrumbSSR,reviewG) {
        super();
        this.entry = entry;
        this.imagesProduct = imagesProduct;
        this.reviewG = reviewG;
        this.link = `https://happynest.vn/shop/${formatSku(entry.sku)}/${getUrlName(entry.name)}.html`;
        const webPage = this.webPage();
        this.schema.push(webPage);
        this.schema.push(this.Product());
        this.schema.push(this.BreadcrumbList(breadCrumbSSR));
        // this.schema.push(this.NewsArticle(entry));
    }

    Product() {
        const priceValidUntil = dayjs().add(7, 'day').format('YYYY-MM-DD');
        const organization = this.organization();
        delete organization["@context"];
        let image = 'https://happynest.vn/v2019/img/logo-seo-happynest.png';
        if(isArray(this.imagesProduct) && this.imagesProduct.length > 0){
            image = this.imagesProduct[0].full;
        }
        const hasMerchantReturnPolicy = {
            '@type' : 'MerchantReturnPolicy',
            'applicableCountry' : 'VN',
            'returnPolicyCategory' : 'https://schema.org/MerchantReturnFiniteReturnWindow',
            'merchantReturnDays' : '30',
            'returnMethod' : 'https://schema.org/ReturnByMail',
            'returnFees' : 'https://schema.org/FreeReturn',
        }
        const shippingDetails = {
            '@type' : 'OfferShippingDetails',
            'shippingRate' : {
                'value' : '0',
                'currency' : 'VND',
            },
            'shippingDestination' : {
                '@type': 'DefinedRegion',
                'addressCountry': 'VN',
            },
            'deliveryTime' : {
                '@type': 'ShippingDeliveryTime',
                'handlingTime': {
                    '@type': 'QuantitativeValue',
                    'minValue': '0',
                    'maxValue': '1',
                    'unitCode': 'DAY'
                },
                'transitTime': {
                    '@type': 'QuantitativeValue',
                    'minValue': '1',
                    'maxValue': '5',
                    'unitCode': 'DAY',
                },
            }
        }
        const schema = {
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": this.entry.name,
            "image": [image],
            "description": this.entry.custom_attributes?.meta_description || this.entry.name,
            "sku": this.entry.sku,
            "mpn": this.entry.sku,
            "offers": {
                "@type": "Offer",
                "url": this.link,
                "priceCurrency": "VND",
                "price": this.entry.price,
                "priceValidUntil" : priceValidUntil,
                "itemCondition": "https://schema.org/NewCondition",
                "availability": "https://schema.org/InStock",
                "seller": organization,
                "hasMerchantReturnPolicy" : hasMerchantReturnPolicy,
                "shippingDetails" : shippingDetails
            },
        };
        if (typeof this.entry.extension_attributes.detail_information != 'undefined' && this.entry.extension_attributes.detail_information.length > 0) {
            schema["additionalProperty"] = [];
            for (const [key, item] of Object.entries(this.entry.extension_attributes.detail_information)) {
                schema["additionalProperty"].push({
                    "@type": "PropertyValue",
                    "name": item.label,
                    "value": item.value,
                });
                if (item.code === "brand") {
                    schema["brand"] = {
                        "@type": "Brand",
                        "name": item.value
                    };
                }
            }
        }
        schema["review"] = {
            "@type": "Review",
            "reviewRating": {
                "@type": "Rating",
                "bestRating" : 5,
                "ratingValue": 5
            },
            "author":{
                "@type":"Person",
                "name":"Happynest"
            }
        };

        if(isArray(this.reviewG) && this.reviewG.length > 0){
            schema["review"] = [];
            for (const [key, item] of Object.entries(this.reviewG)) {
                let rating = 3;
                if(isArray(item.ratings) && typeof item.ratings[0].value != "undefined"){
                    rating = item.ratings[0].value;
                }
                schema["review"].push({
                    "@type": "Review",
                    "reviewRating": {
                        "@type": "Rating",
                        "ratingValue": rating,
                        "bestRating": "5"
                    },
                    "author": {
                        "@type": "Person",
                        "name": item.nickname
                    }
                })
            }
        }
        schema["aggregateRating"] = {
            "@type": "AggregateRating",
            "bestRating": 5,
            // "worstRating": 5,
            "ratingValue": 5,
            "reviewcount": 1
        };
        if (typeof this.entry.extension_attributes.rating_summary != "undefined" && this.entry.extension_attributes.rating_summary > 0) {
            // schema["aggregateRating"] = {
            //     "@type": "AggregateRating",
            //     "bestRating": 5,
            //     "worstRating": 1,
            //     "ratingValue": this.entry.extension_attributes.rating_summary,
            //     "reviewcount": this.entry.extension_attributes.reviews_count
            // };
            schema["aggregateRating"]["ratingValue"] = this.entry.extension_attributes.rating_summary;
            schema["aggregateRating"]["reviewcount"] = this.entry.extension_attributes.reviews_count;
        }
        return schema;
    }

    BreadcrumbList(items = []) {
        const schemas = {
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            "itemListElement": []
        };
        schemas.itemListElement.push({
            "@type": "ListItem",
            "position": 1,
            "item": {
                "id": "https://happynest.vn/",
                "@type": "Thing",
                "name": "Happynest",
                "url": "https://happynest.vn/"
            }
        });
        if (items.length > 0) {
            for (const [key, item] of Object.entries(items)) {
                schemas.itemListElement.push({
                    "@type": "ListItem",
                    "position": item.level,
                    "item": {
                        "@type": "Thing",
                        "id": item.url,
                        "name": item.name,
                        "url": item.url
                    }
                });
            }
            schemas.itemListElement.push({
                "@type": "ListItem",
                "position": items.length + 2,
                "item": {
                    "@type": "Thing",
                    "id": this.link,
                    "name": this.entry.name,
                    "url": this.link,
                }
            });
        }
        return schemas;
    }

    NewsArticle() {
        const data = {
            "@context": "https://schema.org/", "@type": "NewsArticle",
        };
        const organization = this.organization();
        delete organization["@context"];
        const webPage = this.webPage();
        delete webPage["@context"];
        if (typeof this.entry.seo != "undefined") {
            data["@id"] = this.entry.show_url;
            data['name'] = this.entry.title;
            data["headline"] = this.entry.seo.title;
            data["description"] = this.entry.seo.description;
            data["thumbnailUrl"] = this.entry.storage_thumbnail_url;
            data["author"] = {
                "@type": "Person",
                "name": this.entry.user.fullname,
                "description": this.entry.user.bio,
                "url": this.entry.user.wall_url,
                "image": {
                    "@type": "ImageObject",
                    "@id": this.entry.avatar + '#image',
                    "url": this.entry.avatar,
                    "caption": this.entry.user.full_name,
                    "inLanguage": "vi"
                }
            };
            data["publisher"] = organization;
            data["datePublished"] = dayjs(this.entry.created_at, "Y-m-d\\TH:i:s");
            data["dateModified"] = dayjs(this.entry.updated_at, "Y-m-d\\TH:i:s");
            data["keywords"] = (this.entry.seo.keywords === "" || this.entry.seo.keywords == null) ? "" : this.entry.seo.keywords.split(", ");
            data["mainEntityOfPage"] = webPage;
            data["inLanguage"] = "vi";
            data["isPartOf"] = {
                "@id": this.entry.show_url
            };
        }
        if (typeof this.entry.images != "undefined" && this.entry.images.data.length > 0) {
            data["image"] = [];
            for (const [key, item] of Object.entries(this.entry.images.data)) {
                data["image"].push(item.storage_url);
            }
        }
        return data;
    }

    webPage() {
        const data = {
            "@context": "https://schema.org/",
            "@type": "WebPage",
        };
        if (typeof this.entry.id != "undefined") {
            data["name"] = this.entry.name;

            data["description"] = this.entry.custom_attributes?.meta_description || this.entry.name;
            data['url'] = this.link;
            // data["datePublished"] = dayjs(entry.created_at, "Y-m-d\\TH:i:s");
            // data["dateModified"] = dayjs(entry.updated_at, "Y-m-d\\TH:i:s");
            // data["isPartOf"] = {
            //     "@type" : "WebSite",
            //     "url" : "https://happynest.vn/",
            //     "potentialAction": {
            //         "@type": "SearchAction",
            //         "target": {"@type": "EntryPoint", "urlTemplate": "https://happynest.vn/tim-kiem?keyword={keyword}"},
            //         "query-input": {
            //             "@type": "PropertyValueSpecification",
            //             "valueRequired": "http://schema.org/True",
            //             "valueName": "keyword"
            //         }
            //     }
            // };
            // data["primaryImageOfPage"] = {
            //     "@type"  : "ImageObject",
            //     "@id" : entry.storage_thumbnail_url+'/#imageObject',
            //     "url" : entry.storage_thumbnail_url,
            //     "width" : "800",
            //     "height" : "400",
            //     "caption" : entry.title,
            //     "inLanguage" : "vi"
            // };
            // data["inLanguage"] = "vi";
        }
        return data;
    }
}